import { render } from "./CheckboxesExample.vue?vue&type=template&id=55916633"
import script from "./CheckboxesExample.vue?vue&type=script&lang=js"
export * from "./CheckboxesExample.vue?vue&type=script&lang=js"

import exportComponent from "/builds/strooka-jagaad/strooka-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__